<template>
  <div>
    <h2>Selected candidates will be updated here</h2>
    <table
      style="width: -webkit-fill-available; height: auto; text-align: center"
    >
      <tr>
        <th>Post</th>
        <th>Link</th>
      </tr>
      <tr>
        <td style="margin: 25px; font-size: 16px; font-weight: 500">
          Heavy Vehicle Driver
        </td>
        <td style="text-align: left !important">
          <a
            href="https://drive.google.com/file/d/1skx7zFQOSn3WlUuPKkHBGn9_41Ta2stM/view?usp=sharing"
            target="_blank"
            style="color: #009688"
          >
            <i class="fas fa-download"></i>
            View
            <i class="fas fa-file-pdf" style="color: red"></i>
          </a>
        </td>
      </tr>
      <tr>
        <td style="margin: 25px; font-size: 16px; font-weight: 500">
          Light Vehicle Driver
        </td>
        <td style="text-align: left !important">
          <a
            href="https://drive.google.com/file/d/1x77um5xMrGQBFQqa1y8V7xzeGOLqTGmB/view?usp=sharing"
            target="_blank"
            style="color: #009688"
          >
            <i class="fas fa-download"></i>
            View
            <i class="fas fa-file-pdf" style="color: red"></i>
          </a>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
</style>
